import styled, { css } from 'styled-components';
import { CSSProperties } from 'react';

import { red, green, black, gray, formColor1 } from 'utils/style/colors';

import Badge from 'components/Badge';
import Button from 'components/Button';
import HoverIcon from 'components/HoverIcon';

interface IDropzoneProps {
  isDragActive: boolean;
  isDragAccept: boolean;
  isDragReject: boolean;
}

export const StyledDropzone: CSSProperties = {
  margin: '2em 1em',
  display: 'flex',
  position: 'relative',
  justifyContent: 'space-between',
  width: '100%',
};

export const DragAndDrop = styled('div')`
  border-radius: 10px;
  text-align: center;
  line-height: 34px;
  font-size: 11px;
  font-weight: 500;
`;

export const Wrapper = styled('div')<
  IDropzoneProps & { $largePreview?: boolean }
>`
  width: 100%;
  height: ${({ largePreview }) => (largePreview ? '360px' : '200px')};
  display: flex;
  position: relative;
  border: 2px dashed ${formColor1};
  border-radius: 20px;
  justify-content: center;
  background-color: ${gray};

  ${(props) =>
    props.isDragActive &&
    css`
      border-style: solid;
      background-color: ${gray};
    `};

  ${(props) =>
    props.isDragAccept &&
    css`
      ${DragAndDrop} {
        color: ${green};
      }
      border-color: ${green};
      border-style: solid;
      background-color: ${gray};
    `};

  ${(props) =>
    props.isDragReject &&
    css`
      ${DragAndDrop} {
        color: ${red};
      }
      border-style: solid;
      border-color: ${red};
      background-color: ${gray};
    `};
`;

export const ThumbContainer = styled.aside`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: row;
`;

export const Remove = styled(HoverIcon)`
  margin: 1.5em 0.6em;
  position: absolute;
  align-self: normal;
`;

export const InfoBox = styled('div')`
  align-self: flex-start;
  display: flex;
  justify-content: space-between;
  color: ${black};
`;

export const UploadButton = styled(Button)`
  align-self: stretch;
`;

export const Text = styled.p`
  text-align: right;
  word-break: break-all;
  font-weight: 400;
`;

export const Formats = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`;

export const Type = styled(Badge)`
  color: #fff;
  display: flex;
  width: auto;
  padding: 0.5rem 0.75rem;
`;

export const FileUploadContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
